define('components/course/collections/themes',[
    'components/asset-player/collections/assets',
    'components/asset-player/models/media-file',
    'components/course/models/theme',
    'components/course/radio-channel'
], function (assets, MediaFile, Theme, channel) {
    "use strict";

    var ThemeEvent = channel.Event.Theme;

    return Backbone.Collection.extend({
        "model": Theme,

        "initialize": function () {
            this.initRadioComm();
        },

        "initRadioComm": function () {
            channel.reply(ThemeEvent.GET, this.retrieveThemes, this);
        },

        "retrieveThemes": function (themesList) {
            var assetList = [],
                deferred = new $.Deferred();

            _.each(themesList, function (themeGuid) {
                assetList.push({
                    "guid": themeGuid
                });
            });

            assets.retrieveAssets(assetList)
                .promise
                .done(_.bind(function (loadedAssets) {
                    var loadedThemes = [];

                    _.each(loadedAssets.all, function (asset) {
                        var theme,
                            themeUrl,
                            mediaFile;

                        mediaFile = asset.get('mediaFiles').findWhere({
                            "typeId": MediaFile.Type.HYPER_TEXT_MARKUP_LANGUAGE_5
                        });

                        if (!mediaFile) {
                            return;
                        }

                        themeUrl = mediaFile.get('url');

                        // Ensure slash at the end of the URL
                        themeUrl = themeUrl.replace(/([^\/])$/, '$1/');

                        theme = new Theme({
                            "guid": asset.get('guid'),
                            "url": window.initData.appUrl + themeUrl
                        });

                        loadedThemes.push(theme);
                    }, this);

                    deferred.resolveWith(this, [loadedThemes]);
                }, this))
                .fail(_.bind(function () {
                    deferred.rejectWith(this);
                }, this));

            return deferred.promise();
        }
    });
});

